import * as React from 'react'
import messages from './messages'
import { Container, RightButtons } from './styledComponents'
import ColorButton from '../../ColorButton'
import ShuffleButonV1 from '../ShuffleButonV1'

interface Props {
  colorBlock?: number
  colorBlockHovered: number
  colors: string[]
  names: string[]
  excludedAreas: any
  isExternal?: boolean
  onSelectColorBlock: (index: number) => void
  onSelectShuffle: (e: React.MouseEvent) => void
  onHoverColorBlock: (index: number) => void
  formatMessage: (messageDescriptor: any, params?: any) => string
  showColorPallet: () => void
}

const { area } = messages
const extAreas = ['Left Panel', 'Right Panel', 'Back Panel', 'Top Panel', 'Front Panel']

class ColorButtons extends React.Component<Props, {}> {
  render() {
    const {
      formatMessage,
      colorBlockHovered,
      onSelectColorBlock,
      showColorPallet,
      onHoverColorBlock,
      onSelectShuffle,
      excludedAreas = {},
      isExternal,
      colors,
      colorBlock = -1,
      names
    } = this.props

    const colorButtons = colors.map((label, index) => {
      const name = names[index]
      return !excludedAreas[index] ? (
        <ColorButton
          key={index}
          label={isExternal ? extAreas[index] : formatMessage(area, { index: index + 1 })}
          {...{
            name,
            index,
            colorBlockHovered,
            onSelectColorBlock,
            showColorPallet,
            onHoverColorBlock
          }}
          currentColor={colors[index]}
          selected={colorBlock === index}
        />
      ) : null
    })

    return (
      <Container {...{ isExternal }}>
        {colorButtons}
        {colorButtons.length > 0 && (
          <RightButtons>
            {colorButtons.length > 1 && <ShuffleButonV1 onClick={onSelectShuffle} {...{ formatMessage }} />}
          </RightButtons>
        )}
      </Container>
    )
  }
}

export default ColorButtons



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/ColorButtons/index.tsx